/* eslint-disable prefer-template */
import React from 'react';
import { BuilderComponent, builder, useIsPreviewing } from '@builder.io/react';
import DefaultErrorPage from 'next/error';
import { BuilderContent } from '@builder.io/sdk';
import { GetServerSideProps } from 'next';
import { TRegionKey } from '@source/interface';
import { COOKIE_KEYS, BUILDER_PUBLIC_API_KEY, isProduction } from '@source/constants/common';
import { getCurrentRegion } from '@source/utils/utils';
import HeadMeta from '@source/pages/Home/components/HeadMeta';

import '../../src/builder-registry';

import Layout from '@source/components/Layout';

builder.init(BUILDER_PUBLIC_API_KEY);

// Define a function that fetches the Builder
// content for a given page
export const getServerSideProps: GetServerSideProps = async ({ params, locale, req }) => {
  const cookieRegion = req.cookies?.[COOKIE_KEYS.STORED_REGION];

  const currentRegion = await getCurrentRegion({
    urlRegion: locale as TRegionKey,
    cookieRegion: cookieRegion as TRegionKey,
  });

  // available only for jp and production env
  if (!isProduction || currentRegion !== 'jp') {
    return {
      notFound: true,
    };
  }

  // Fetch the builder content for the given page
  const page = await builder
    .get('page', {
      userAttributes: {
        urlPath: '/careers' + ((params?.page as string[])?.join('/') || ''),
      },
    })
    .toPromise();

  // Return the page content as props
  return {
    props: {
      page: page || null,
      region: currentRegion,
    },
  };
};

// Define the Page component
export default function Page({ page, region: countryCode }: { page: BuilderContent | null; region: TRegionKey }) {
  const isPreviewing = useIsPreviewing();

  // If the page content is not available
  // and not in preview mode, show a 404 error page
  if (!page && !isPreviewing) {
    return <DefaultErrorPage statusCode={404} />;
  }
  console.log(page);
  // If the page content is available, render
  // the BuilderComponent with the page content
  return (
    <Layout>
      <HeadMeta
        metaKey="home"
        region={countryCode as TRegionKey}
        metaData={{
          title: page?.data?.title || '',
          metaTitle: page?.data?.title || '',
          description: page?.data?.description || '',
        }}
      />
      <BuilderComponent model="page" content={page || undefined} />
    </Layout>
  );
}
